<template>
  <OmtLayoutContainer :minHeight="['initial', 'calc(100vh - 80px)']" :alignContent="['', 'flex-start']">
    <OmtRow>
      <OmtTypography as="h1-bold" mb="24px">Extrato de reembolso</OmtTypography>
    </OmtRow>

    <OmtRow mb="8px">
      <CBox cursor="pointer" @click="openBeneficiaryModal">
        <OmtTypography as="h3-regular" mb="15px" color="var(--colors-light-primary-gray2)">
          Por beneficiário
        </OmtTypography>
        <CFlex justify-content="space-between" align-items="center">
          <OmtTypography as="h3-bold" color="var(--colors-light-primary-gray1)">
            {{ formatName(beneficiario.label) }}
          </OmtTypography>
          <OmtIcons name="fa-solid fa-chevron-down" size="sm"></OmtIcons>
        </CFlex>
        <omt-divider></omt-divider>
      </CBox>
    </OmtRow>

    <OmtRow mb="24px">
      <CBox cursor="pointer" @click="openPeriodModal">
        <OmtTypography as="h3-regular" mb="15px" color="var(--colors-light-primary-gray2)"
          >Selecione o período
        </OmtTypography>
        <CFlex justify-content="space-between" align-items="center">
          <OmtTypography as="h3-bold" color="var(--colors-light-primary-gray1)">
            {{ periodo.label }}
          </OmtTypography>
          <OmtIcons name="fa-solid fa-chevron-down" size="sm"></OmtIcons>
        </CFlex>
        <omt-divider></omt-divider>
      </CBox>
    </OmtRow>

    <OmtStickedModal v-if="showBeneficiaryModal" @close="closeBeneficiaryModal">
      <CBox mb="24px">
        <OmtTypography as="h1-bold" lineHeight="32px">Selecione o beneficiário para visualizar o extrato</OmtTypography>
      </CBox>
      <CBox mb="23px">
        <CRadioGroup v-model="selectedBeneficiary">
          <CRadio
            v-for="(item, index) in beneficiariesOptions"
            :key="index"
            :value="item.value"
            cursor="pointer"
            :mb="index !== beneficiariesOptions.length - 1 ? '16px' : ''"
          >
            <OmtTypography as="h3-semi-bold"> {{ formatName(item.label) }} </OmtTypography>
          </CRadio>
        </CRadioGroup>
      </CBox>
      <OmtButton :w="['100%', '308px !important']" size="sm" @click="applyBeneficiarySelection">
        <OmtTypography as="button-medium" color="#FFFFF">Aplicar</OmtTypography>
      </OmtButton>
    </OmtStickedModal>

    <OmtStickedModal v-if="showPeriodModal" @close="closePeriodModal">
      <CBox mb="24px">
        <OmtTypography as="h1-bold" lineHeight="32px">Selecione o período</OmtTypography>
      </CBox>
      <CBox mb="23px">
        <CRadioGroup v-model="selectedPeriod">
          <CRadio
            v-for="(item, index) in periodosOptions"
            :key="index"
            :value="item.value"
            cursor="pointer"
            :mb="index !== periodosOptions.length - 1 ? '16px' : ''"
          >
            <OmtTypography as="h3-semi-bold"> {{ item.label }} </OmtTypography>
          </CRadio>
        </CRadioGroup>
      </CBox>
      <OmtButton :w="['100%', '308px !important']" size="sm" @click="applyPeriodSelection">
        <OmtTypography as="button-medium" color="#FFFFF">Aplicar</OmtTypography>
      </OmtButton>
    </OmtStickedModal>

    <FixedButtonRow>
      <OmtButton :w="['100%', '308px !important']" @click="download">
        <OmtTypography as="h1-bold" color="#FFFFFF">Baixar extrato</OmtTypography>
      </OmtButton>
    </FixedButtonRow>
  </OmtLayoutContainer>
</template>

<script>
import { mapActions } from "vuex";
import FixedButtonRow from "@/components/Atoms/FixedButtonRow/index.vue";
import { capitalize } from "@/utils/utils";
import Swal from "sweetalert2/dist/sweetalert2.min.js";

export default {
  components: { FixedButtonRow },
  data() {
    return {
      beneficiaries: [],
      options: [],
      beneficiario: {},
      periodo: {},
      selectedBeneficiary: null,
      selectedPeriod: null,
      showBeneficiaryModal: false,
      showPeriodModal: false
    };
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      const opcoes = await this.fetchOpcoesExtrato();
      this.beneficiaries = opcoes.beneficiaries;
      this.options = opcoes.options;
      this.beneficiario = this.beneficiariesOptions.find(b => b.value === "00") || this.beneficiariesOptions[0] || {};
      this.periodo = this.periodosOptions[0];
    } finally {
      this.$root.$emit("hide-loading");
    }
  },
  computed: {
    beneficiariesOptions() {
      return this.beneficiaries.map(b => ({
        label: b.Descricao,
        value: b.Beneficiario ? b.Beneficiario : "todos"
      }));
    },
    periodosOptions() {
      return this.options.map(p => ({
        label: p.Descricao,
        value: p.Codigo
      }));
    }
  },
  methods: {
    ...mapActions("refund", ["fetchOpcoesExtrato", "obterExtrato"]),
    formatName(name) {
      return name ? capitalize(name) : "";
    },
    openBeneficiaryModal() {
      if (!this.selectedBeneficiary) {
        const defaultBeneficiary =
          this.beneficiariesOptions.find(b => b.value === "00") || this.beneficiariesOptions[0];
        if (defaultBeneficiary) {
          this.selectedBeneficiary = defaultBeneficiary.value;
        }
      }
      this.showBeneficiaryModal = true;
    },
    closeBeneficiaryModal() {
      this.showBeneficiaryModal = false;
    },
    applyBeneficiarySelection() {
      if (this.selectedBeneficiary) {
        this.beneficiario = this.beneficiariesOptions.find(b => b.value === this.selectedBeneficiary);
      }
      this.closeBeneficiaryModal();
    },
    openPeriodModal() {
      if (!this.selectedPeriod) {
        this.selectedPeriod = this.periodo?.value || this.periodosOptions[0].value;
      }
      this.showPeriodModal = true;
    },
    closePeriodModal() {
      this.showPeriodModal = false;
    },
    applyPeriodSelection() {
      if (this.selectedPeriod) {
        this.periodo = this.periodosOptions.find(p => p.value === this.selectedPeriod) || this.periodosOptions[0];
      }
      this.closePeriodModal();
    },
    async download() {
      this.$root.$emit("show-loading");
      const response = await this.obterExtrato({
        beneficiario: this.beneficiario.value,
        periodo: this.periodo.value
      });
      this.$root.$emit("hide-loading");
      if (response.errorMsg) {
        Swal.fire({
          title: response.errorMsg,
          confirmButtonText: "OK"
        });
      } else {
        globalThis.window.location = response.link;
      }
    }
  }
};
</script>

<style scoped>
::v-deep label[data-chakra-component="CRadio"] > div[data-chakra-component="CControlBox"] {
  border-color: var(--colors-blue-500);
  background-color: #ffffff;
  width: 17px !important;
  height: 17px !important;
  flex-shrink: 0 !important;
  stroke-width: 1px;
}

::v-deep
  label[data-chakra-component="CRadio"]
  > div[data-chakra-component="CControlBox"]
  span[data-chakra-component="CBox"] {
  display: none;
}

::v-deep input[type="radio"]:checked + div[data-chakra-component="CControlBox"] {
  background-color: white !important;
  border: 1px solid var(--colors-blue-500) !important;
}

::v-deep input[type="radio"]:checked + div[data-chakra-component="CControlBox"] span[data-chakra-component="CBox"] {
  display: block;
  width: 9px;
  height: 9px;
  background-color: var(--colors-blue-500);
  border-radius: 50%;
}
</style>
